import { ArsTableState, ArstActionContextmenuAction } from "../interface";
import { arst_toggleSpaceAfter } from "./arst_toggleSpaceAfter";

/**
 * Toggles the "Space after group" (`spaceAfterGroup`) setting for the row item targeted by a
 * context-menu action. Group and data value labels toggle their parent grouping factor.
 *
 * @param state - Current ARS table state
 * @param action - Context-menu action identifying the selected row cell
 * @returns Updated ARS table state
 */
export const arst_toggleSpaceAfterGroup = <T>(
  state: ArsTableState<T>,
  action: ArstActionContextmenuAction<T>,
): ArsTableState<T> => arst_toggleSpaceAfter(state, action, "spaceAfterGroup");
